import type {ReactElement} from 'react';
import {CROP_SURFACE_ATTRIBUTE} from '@PosterWhiteboard/poster/poster-media-crop/poster-media-crop.types';
import type {CropSurfaceProps} from '@Components/poster-editor/components/crop-surface/crop-surface.types';
import styles from './crop-surface.module.scss';

/**
 * Marks a piece of crop-mode UI as part of the crop area: a press inside it is never the outside
 * click that applies the crop and leaves the mode. Wraps the on-canvas handles and the side-panel
 * options; the mobile sheet carries the same attribute through the modal's content root.
 */
export function CropSurface({children}: CropSurfaceProps): ReactElement {
  return (
    <div className={styles.cropSurface} {...{[CROP_SURFACE_ATTRIBUTE]: 'true'}}>
      {children}
    </div>
  );
}
